var FinancialInstitutionComponent = /** @class */ (function () {
    function FinancialInstitutionComponent() {
    }
    FinancialInstitutionComponent.prototype.ngOnInit = function () {
    };
    return FinancialInstitutionComponent;
}());
export { FinancialInstitutionComponent };



// WEBPACK FOOTER //
// ./src/app/financial-institution/financial-institution.component.ts.pre-build-optimizer.js